<template>
	<div>
		<div style="width: 100%;text-align: right;">
			<div style="width: 100%;text-align: right;">
				<el-date-picker
					style="width: 255px;"
					v-model="time"
					type="daterange"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					format="yyyy-MM-dd">
				</el-date-picker>
				<el-button @click="updateTable" icon="el-icon-search" style="margin-left: 3px;">搜索</el-button>
			</div>
		</div>
		<div style="margin-top: 15px;">
				<el-table ref="multipleTable" 
					 :data="tableData" 
					 style="width: 100%" 
					 element-loading-text="数据正在加载中" 
					 @selection-change="handleSelectionChange"
					 :header-cell-style="headClass"
				 	 :row-style="rowClass">
			      <el-table-column type="selection" width="60"></el-table-column>
			      <el-table-column prop="mid" label="消息id" width="80" sortable></el-table-column>
			      <el-table-column prop="description" label="消息内容"></el-table-column>
			      <el-table-column prop="type" width="120" label="消息类型"></el-table-column>
			      <el-table-column prop="posttime" width="150" label="消息时间" :formatter="dateFormat"></el-table-column>
			  </el-table>
			  <el-pagination background
		    			style="text-align:right;margin-top: 15px;margin-bottom: 55px;"
			            @size-change="handleSizeChange"
			            @current-change="handleCurrentChange"
			            :current-page="currentPage"
			            :page-sizes="[10, 50, 100, 200]"
			            :page-size="pageSize" 
			            layout="total, sizes, prev, pager, next, jumper"
			            :total="total">
			  </el-pagination>
		</div>
	</div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'messageCenter',
  components: {
  },
  data() {
    return {
    	time:[],
    	total: 0,
        currentPage: 1,
        pageSize: 10,
		tableData:[]
    }
  },
  watch: {
  },
  mounted() {
  	this.updateTable();
  },
  beforeDestroy() {
  },
  methods: {
  	getMessage(row){
  		alert(row.mid)
  	},
  	handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  	handleSizeChange(val) {
      this.pageSize = val;
      this.updateTable();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.updateTable();
    },
    updateTable(){
    	var params = {
    		pageId:this.currentPage,
  			size:this.pageSize,
  			type:0
    	};
    	if(this.time != null && this.time.length > 0){
	  		param.beginTime = this.getStandardDate(this.time[0]);
	  		param.endTime = this.getStandardDate(this.time[1]);
	  	}
    	const loading = this.$loading({
          lock: true,
          text: '获取表格数据中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
          loading.close();
        }, 3000);
        var thiz = this;
    	axios.get(this.$store.getters.getApiValue+'/srsMessage/searchMyMessage.do',{
  			params:params
  		}).then(function (response) {
  			loading.close();
		    var data = response.data;
		    if(data.status == "200"){
		    	thiz.total = data.totalCount;
		    	thiz.tableData = data.data;
		    }
		  }).catch(function (error) {
		  	loading.close();
		    console.log(error);
		  });
    },
    dateFormat(row,column){
		var str = row[column.property];
		if(str == null || str == ""){
			return "";
		}else{
			return this.getStandardDate(new Date(str));
		}
	},
    getStandardDate(val){
    	var year = val.getFullYear();
        var month = val.getMonth() + 1;
        var day = val.getDate();
        month = month < 10 ? "0"+month : month;
        day = day < 10 ? "0"+day : day;
        return year+"-"+month+"-"+day;
    },
    headClass({ row, rowIndex}) {
    	if(rowIndex == 0){
    		return ''
    	}
	    return ''
		},
	  rowClass({ row, rowIndex}) {
		    if(rowIndex%2 == 0){
		    	return 'background:#F1F2F7;'
		    }else{
		    	return 'background:white;'
		    }
		    return ''
		}
  }
}
</script>

<style>
	.el-table{
	  	font-size: 12px;
	  	border-bottom: 1px solid #dcd8d8;
	  	color: black;
	}
	.el-table tr th{
	    border-top: 0px;
	  	border-left: 0px;
	  	border-right: 0px;
	}
	.el-table tr td{
	  	border-bottom: 1px solid #dcd8d8;
 	}
</style>